function init() {
    InitBlogLanding();
}
function InitBlogLanding() {

    // toggle mobile filtering
  
    $(".blog-landing-filters__mobile-controls-toggle button").click(function () {
  
      $(".blog-landing-filters__container").addClass("open");
  
    });
  
    $(".blog-landing-filters__mobile-controls .btn").click(function (e) {
  
      e.preventDefault();
  
      $(".blog-landing-filters__container").removeClass("open");
  
    });
  
    $(".blog-landing-categories__container [view-more]").click(function (e) {
  
      e.preventDefault();
  
      if ($(".blog-landing-categories__container").hasClass("view-more")) {
  
        $(".blog-landing-categories__container").removeClass("view-more");
        $(".blog-landing-categories__container [view-more]").html("VIEW MORE");
  
      } else {
  
        $(".blog-landing-categories__container").addClass("view-more");
        $(".blog-landing-categories__container [view-more]").html("VIEW LESS");
  
      } // end if
  
    });
  
    $("body").on("click", ".blog-landing .feature-card__body__date, .blog-landing-results .feature-card__body__date", function (e) {
  
      e.preventDefault();
      e.stopPropagation();
  
      var url = this.getAttribute("data-href");
  
      if (url) {
  
        window.location.href = url;
  
      }
  
    });
  
    // background ripple effect for water category header
  
    if ($(".blog-category-header.water-ripple").length) {
  
      $(".blog-category-header.water-ripple").ripples({
  
        resolution: 512,
        dropRadius: 20,
        perturbance: 0.04,
  
      }).addClass("water");
  
    }
  }
export {
    init
}